/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockOrderCheckInfoOrderCheckGoodsVo } from './StockOrderCheckInfoOrderCheckGoodsVo';
import {
    StockOrderCheckInfoOrderCheckGoodsVoFromJSON,
    StockOrderCheckInfoOrderCheckGoodsVoFromJSONTyped,
    StockOrderCheckInfoOrderCheckGoodsVoToJSON,
    StockOrderCheckInfoOrderCheckGoodsVoToJSONTyped,
} from './StockOrderCheckInfoOrderCheckGoodsVo';
import type { StockOrderCheckInfoErrorGoodsProcessVo } from './StockOrderCheckInfoErrorGoodsProcessVo';
import {
    StockOrderCheckInfoErrorGoodsProcessVoFromJSON,
    StockOrderCheckInfoErrorGoodsProcessVoFromJSONTyped,
    StockOrderCheckInfoErrorGoodsProcessVoToJSON,
    StockOrderCheckInfoErrorGoodsProcessVoToJSONTyped,
} from './StockOrderCheckInfoErrorGoodsProcessVo';

/**
 * 
 * @export
 * @interface StockOrderCheckInfoVo
 */
export interface StockOrderCheckInfoVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof StockOrderCheckInfoVo
     */
    orderCode?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof StockOrderCheckInfoVo
     */
    warehouseName?: string;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof StockOrderCheckInfoVo
     */
    orderStatusName?: string;
    /**
     * 请求分组
     * @type {string}
     * @memberof StockOrderCheckInfoVo
     */
    requestGroup?: string;
    /**
     * 购买类型 1 代买服务 2 转运服务
     * @type {number}
     * @memberof StockOrderCheckInfoVo
     */
    buyType?: number;
    /**
     * 商品检查单列表
     * @type {Array<StockOrderCheckInfoOrderCheckGoodsVo>}
     * @memberof StockOrderCheckInfoVo
     */
    orderCheckGoods?: Array<StockOrderCheckInfoOrderCheckGoodsVo>;
    /**
     * 错误商品处理列表
     * @type {Array<StockOrderCheckInfoErrorGoodsProcessVo>}
     * @memberof StockOrderCheckInfoVo
     */
    errorGoodsProcess?: Array<StockOrderCheckInfoErrorGoodsProcessVo>;
}

/**
 * Check if a given object implements the StockOrderCheckInfoVo interface.
 */
export function instanceOfStockOrderCheckInfoVo(value: object): value is StockOrderCheckInfoVo {
    return true;
}

export function StockOrderCheckInfoVoFromJSON(json: any): StockOrderCheckInfoVo {
    return StockOrderCheckInfoVoFromJSONTyped(json, false);
}

export function StockOrderCheckInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOrderCheckInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
        'orderCheckGoods': json['orderCheckGoods'] == null ? undefined : ((json['orderCheckGoods'] as Array<any>).map(StockOrderCheckInfoOrderCheckGoodsVoFromJSON)),
        'errorGoodsProcess': json['errorGoodsProcess'] == null ? undefined : ((json['errorGoodsProcess'] as Array<any>).map(StockOrderCheckInfoErrorGoodsProcessVoFromJSON)),
    };
}

export function StockOrderCheckInfoVoToJSON(json: any): StockOrderCheckInfoVo {
    return StockOrderCheckInfoVoToJSONTyped(json, false);
}

export function StockOrderCheckInfoVoToJSONTyped(value?: StockOrderCheckInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'warehouseName': value['warehouseName'],
        'orderStatusName': value['orderStatusName'],
        'requestGroup': value['requestGroup'],
        'buyType': value['buyType'],
        'orderCheckGoods': value['orderCheckGoods'] == null ? undefined : ((value['orderCheckGoods'] as Array<any>).map(StockOrderCheckInfoOrderCheckGoodsVoToJSON)),
        'errorGoodsProcess': value['errorGoodsProcess'] == null ? undefined : ((value['errorGoodsProcess'] as Array<any>).map(StockOrderCheckInfoErrorGoodsProcessVoToJSON)),
    };
}

